import React from 'react';
import { PriceText } from 'widget';
import styles from './index.modules.less';
import { Flex } from 'antd-mobile';
import { ImgWrap } from 'pubBiz';
import Text from '@/components/Text';
import CornerMarker from '@/components/CornerMarker';
import { AddCart } from '@/components/AddCart';
import { getPrecision } from 'biz-micro-services-ui/project/middlePlatform/utils/formatMoney';

export default ({ item, sourceTag }) => {
  const { itemInfo } = item || {};
  const { price, code, name, imgUrl, cornerMarkerRespDto, id, skuId, type } = itemInfo || {};
  const params = {
    itemName: name,
    itemNum: 1,
    itemSerial: id,
    skuSerial: skuId,
    price
  };
  if (sourceTag) {
    params.referrer = `${sourceTag}-加入购物车`;
  }
  return (
    <Flex
      direction="column"
      className={styles.outView}
      align="start"
      onClick={() => {
        window.app.routerGoTo({
          pathname: `/shop/productDetail/${id}?type=${type}`,
          state: { sourceTag: sourceTag }
        });
      }}>
      <Flex className={styles.topArea}>
        <ImgWrap className={styles.mainImg} src={imgUrl} />
        <CornerMarker cornerMarkerRespDto={cornerMarkerRespDto} />
      </Flex>
      <Flex className={styles.bottomView} align="start" direction="column">
        <Text numberOfLines={1} className={styles.title}>
          {name}
        </Text>
        <Text className={styles.codeArea}>{code || ''}</Text>
        <Flex justify="between" style={{ width: '100%' }}>
          <PriceText
            value={price || 0}
            precision={getPrecision(price || 0)}
            showIcon
            unitClassName={styles.priceUnit}
            integerClassName={styles.priceText}
            decimalClassName={styles.priceText}
            showLessZero
          />
          <Flex className={styles.image}>
            <AddCart params={params} type={type} itemInfo={itemInfo} />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};



// WEBPACK FOOTER //
// ./src/pages/Shop/Home/ShopHome/components/Tabs/Components/GoodsItem/index.js